var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiskFunctions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 10.75,
    transform: "translate(.752 .696)",
    fill: "#FFF",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M12.5 7v7.063"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    cx: 12.5,
    cy: 18,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskFunctions);
export default __webpack_public_path__ + "static/media/risk-functions.9f2cd7ca015b5a25d80a29cec3643fc3.svg";
export { ForwardRef as ReactComponent };